import React, {useState} from 'react'
import productPromotion from '../../img/productPromotion.webp'
import greeting from '../../img/greeting.webp'
import orgIcon from '../../img/orgIcon.svg'
import bulkUpload from '../../img/bulkUpload.svg'
import {PageTitle} from 'layout/master-layout'
import {useNavigate} from 'react-router-dom'
import {CardItem} from 'models/ActiveManagement'
import {useTranslation} from 'react-i18next'

type IProps = {
 hidePartent: boolean
 setHideParent: (newState: boolean) => void
}

const ActivityManagement = (props: IProps) => {
 const navigate = useNavigate()
 const {t} = useTranslation()
 const cards: CardItem[] = [
  {
   title: t('activityManagement.productPromotion'),
   icon: productPromotion,
   onClick: () => {
    navigate('product-promotion')
   },
  },
  {
   title: t('activityManagement.festiveGreetings'),
   icon: greeting,
   onClick: () => {
    navigate('festive-greeting')
   },
  },
  {
   title: t('activityManagement.viewOrganisation'),
   icon: orgIcon,
   onClick: () => {
    navigate('view-organisation')
   },
  },
  {
   title: t('activityManagement.bulkUpload'),
   icon: bulkUpload,
   onClick: () => {
    navigate('bulk-upload-management')
   },
  },
 ]
 return (
  <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6'>
   {cards.map((card, index) => (
    <div
     key={index}
     className='border rounded-xl  shadow-sm bg-white hover:shadow-md cursor-pointer transition p-3 h-[205px]'
     onClick={() => {
      props.setHideParent(true)
      card.onClick()
     }}
    >
     <div className='flex justify-center items-center mb-4 bg-[#F5F8FA] p-5 rounded-[8px]'>
      <img
       src={card.icon}
       alt={card.title}
       className='w-20 h-20'
      />
     </div>
     <p
      className='text-center'
      style={{
       fontSize: '18px',
       fontWeight: 500,
       color: '#4D4D4D',
      }}
     >
      {card.title}
     </p>
    </div>
   ))}
  </div>
 )
}

export default function ActivityManagementWrapper() {
 const {t} = useTranslation()
 const [hidePartent, setHideParent] = useState(false)
 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full '>
    {!hidePartent && (
     <PageTitle
      breadcrumbContainerClass={
       'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] '
      }
      breadcrumbs={[
       {
        title: t('breadCrumbs.home'),
        path: '/home-page',
        isActive: false,
       },
       {
        title: t('breadCrumbs.activityManagement'),
        path: '',
        isActive: true,
       },
      ]}
      description='Welcome'
     >
      {t('breadCrumbs.activityManagement')}
     </PageTitle>
    )}
    <ActivityManagement
     hidePartent={hidePartent}
     setHideParent={setHideParent}
    />
   </div>
  </div>
 )
}
